<template>
  <v-row>
    <v-col cols="12" sm="12">
      <v-card>
        <v-card-title>{{ $t("Tapahtumat") }}</v-card-title>
        <v-divider></v-divider>

        <eventlist :events="events"></eventlist>
        <!-- <v-list two-line>
          <template v-for="(e, index) in events">
            <v-list-item
              :key="e.id"
              :to="{ name: 'event', params: { id: e.id } }"
            >
              <v-list-item-avatar tile>
                <v-img :src="tenant.logo.thumbnail"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="e.title"></v-list-item-title>

                <v-list-item-subtitle>
                  {{ getEventTime(e) }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text>
                  {{ e.group_name }}
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < events.length - 1"
              :key="`divider-${e.id}`"
            ></v-divider>
          </template>
        </v-list> -->
        <div class="d-flex align-end flex-column mt-3" v-if="pages > 1">
          <v-pagination
            v-model="page"
            :length="pages"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import api from "@/api";
import useAuth from "@/useAuth";
import {
  getDate,
  getDateTime,
  getShortDate,
  getTime,
} from "@/@core/utils/datetime_helpers";
import eventlist from "@/components/events/eventlist.vue";
import moment from "moment";

export default {
  components: {
    eventlist,
  },
  setup() {
    const page = ref(1);
    const totalCount = ref(0);
    const pageSize = 10;
    const events = ref([]);
    const { t } = useTranslations();
    const { tenant } = useAuth();

    const fetchEvents = async () => {
      const response = await api.getEvents(page.value, pageSize);

      if (response.ok) {
        events.value = response.data.results;
        totalCount.value = response.data.count;
      } else {
        alert(response.error);
      }
    };

    watch(page, () => {
      fetchEvents();
    });

    onMounted(() => {
      fetchEvents();
    });

    const pages = computed(() => {
      return Math.ceil(totalCount.value / pageSize);
    });

    const getEventTime = (event) => {
      if (event.end_time) {
        if (moment(event.time).isSame(event.end_time, "day")) {
          return (
            getShortDate(event.time) +
            " klo " +
            getTime(event.time) +
            "-" +
            getTime(event.end_time)
          );
        } else {
          return (
            getShortDate(event.time) +
            " " +
            getTime(event.time) +
            " - " +
            getShortDate(event.end_time) +
            " " +
            getTime(event.end_time)
          );
        }
      }
      return getDateTime(event.time);
    };

    return {
      page,
      totalCount,
      events,
      pages,
      getDateTime,
      getEventTime,
      tenant,
      t,
    };
  },
};
</script>

<style>
</style>